import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../environments/environment";
import { NameId } from "../models/nameId";
import { HttpClient } from "@angular/common/http";
import { QuarterResponse } from "app/models/quarter-response";
import { Quarter } from "app/models/Quarter";

const URL = environment.apiBaseUrl;

@Injectable()
export class QuarterService {
  get openQuarterExists(): boolean {
    return this._openQuarterExists;
  }

  constructor(private http: HttpClient) {}

  private _openQuarterExists: boolean;

  public quarters(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean
  ): Observable<QuarterResponse> {
    const url =
      `${URL}quarters?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}`;

    return this.http.get(url).map((x: any) => {
      const res: QuarterResponse = {
        quarters: x.data as Quarter[],
        total: x.total
      };
      this._openQuarterExists = x.openQuarterExists;
      return res;
    });
  }

  public addQuarter(quarter: Quarter) {
    return this.http.post(`${URL}quarters`, quarter);
  }

  public getQuarter(id: number): Observable<Quarter> {
    return this.http.get<Quarter>(`${URL}quarters/${id}`);
  }

  public updateQuarter(quarter: Quarter) {
    return this.http.put(`${URL}quarters`, quarter);
  }

  public closeQuarter(id: number) {
    const url = `${URL}quarters/close/${id}`;
    return this.http.post(url, null);
  }

  public openQuarter(id: number) {
    const url = `${URL}quarters/open/${id}`;
    return this.http.post(url, null);
  }

  public getAllSimple(): Observable<NameId[]> {
    return this.http.get<NameId[]>(`${URL}quarters/list`);
  }

  public getAllQuarterDataPoints(): Observable<Quarter[]> {
    return this.http.get<Quarter[]>(`${URL}quarters/listAllData`);
  }

  public getOpenQuarter(): Observable<Quarter> {
    return this.http.get<Quarter>(`${URL}quarters/openQuarter`);
  }
}
